"use client"

import { useEffect, useState } from "react"
import { Edit, Trash2, CheckCircle } from "lucide-react"
import Modal from "react-modal"

// Importante: Defina o elemento raiz do seu aplicativo para acessibilidade
Modal.setAppElement("#root")

const UserManagement = () => {
  const [usuariosAtivos, setUsuariosAtivos] = useState([])
  const [usuariosPendentes, setUsuariosPendentes] = useState([])
  const [message, setMessage] = useState("")
  const [isActivateModalOpen, setIsActivateModalOpen] = useState(false)
  const [userToActivate, setUserToActivate] = useState(null)
  const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false)
  const [userToDelete, setUserToDelete] = useState(null)
  const [isEditModalOpen, setIsEditModalOpen] = useState(false)
  const [userToEdit, setUserToEdit] = useState(null)
  const [editedUser, setEditedUser] = useState({})

  useEffect(() => {
    fetchUsers()
  }, [])

  const fetchUsers = () => {
    fetch("https://sismoney.com/painel/usuarios.php")
      .then((response) => response.json())
      .then((res) => {
        setUsuariosAtivos(res.filter((user) => user.ativo === 1))
        setUsuariosPendentes(res.filter((user) => user.ativo === 0))
      })
      .catch((error) => console.error("Erro ao buscar usuários:", error))
  }

  const confirmEditUser = (user) => {
    setUserToEdit(user)
    setEditedUser(user)
    setIsEditModalOpen(true)
  }

  const handleEditUser = () => {
    fetch("https://sismoney.com/painel/usuarios.php", {
      method: "PUT",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(editedUser),
    })
      .then((response) => response.json())
      .then((res) => {
        if (res.success) {
          setMessage("Usuário atualizado com sucesso!")
          fetchUsers()
        } else {
          setMessage(`Erro ao atualizar usuário: ${res.message}`)
        }
      })
      .catch((error) => setMessage("Erro ao atualizar usuário: " + error))
      .finally(() => {
        setIsEditModalOpen(false)
        setUserToEdit(null)
      })
  }

  const confirmActivateUser = (user) => {
    setUserToActivate(user)
    setIsActivateModalOpen(true)
  }

  const handleActivateUser = () => {
    fetch("https://sismoney.com/painel/usuarios.php", {
      method: "PUT",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ idUsuario: userToActivate.idUsuario, ativo: 1, action: "activate" }),
    })
      .then((response) => response.json())
      .then((res) => {
        if (res.success) {
          setMessage("Usuário ativado com sucesso!")
          fetchUsers()
        } else {
          setMessage(`Erro ao ativar usuário: ${res.message}`)
        }
      })
      .catch((error) => setMessage("Erro ao ativar usuário: " + error))
      .finally(() => {
        setIsActivateModalOpen(false)
        setUserToActivate(null)
      })
  }

  const confirmDeleteUser = (user) => {
    setUserToDelete(user)
    setIsDeleteModalOpen(true)
  }

  const handleDeleteUser = () => {
    fetch("https://sismoney.com/painel/usuarios.php", {
      method: "DELETE",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ idUsuario: userToDelete.idUsuario }),
    })
      .then((response) => response.json())
      .then((res) => {
        if (res.success) {
          setMessage("Usuário excluído com sucesso!")
          fetchUsers()
        } else {
          setMessage(`Erro ao excluir usuário: ${res.message}`)
        }
      })
      .catch((error) => setMessage("Erro ao excluir usuário: " + error))
      .finally(() => {
        setIsDeleteModalOpen(false)
        setUserToDelete(null)
      })
  }

  const customModalStyles = {
    content: {
      top: "50%",
      left: "50%",
      right: "auto",
      bottom: "auto",
      marginRight: "-50%",
      transform: "translate(-50%, -50%)",
      backgroundColor: "white",
      borderRadius: "8px",
      padding: "20px",
      maxWidth: "500px",
      width: "100%",
    },
    overlay: {
      backgroundColor: "rgba(0, 0, 0, 0.75)",
    },
  }

  return (
    <div className="space-y-6">
      <div className="flex items-center justify-between">
        <div>
          <h2 className="text-2xl font-bold text-gray-800 dark:text-white">Gerenciamento de Usuários</h2>
          <p className="text-gray-600 dark:text-gray-400">Gerencie os usuários do sistema aqui.</p>
        </div>
      </div>

      <div className="bg-white dark:bg-gray-800 rounded-xl shadow-md p-6 transition-colors duration-200">
        <h3 className="text-lg font-semibold text-gray-700 dark:text-gray-200 mb-4">Usuários Ativos</h3>
        <div className="overflow-x-auto">
          <table className="w-full text-sm text-left text-gray-500 dark:text-gray-400">
            <thead className="text-xs text-gray-700 uppercase bg-gray-50 dark:bg-gray-700 dark:text-gray-400">
              <tr>
                <th scope="col" className="px-6 py-3">
                  ID
                </th>
                <th scope="col" className="px-6 py-3">
                  Email
                </th>
                <th scope="col" className="px-6 py-3">
                  Usuário
                </th>
                <th scope="col" className="px-6 py-3">
                  Telefone
                </th>
                <th scope="col" className="px-6 py-3">
                  Ações
                </th>
              </tr>
            </thead>
            <tbody>
              {usuariosAtivos.map((user) => (
                <tr key={user.idUsuario} className="bg-white border-b dark:bg-gray-800 dark:border-gray-700">
                  <td className="px-6 py-4">{user.idUsuario}</td>
                  <td className="px-6 py-4">{user.email}</td>
                  <td className="px-6 py-4">{user.usuario}</td>
                  <td className="px-6 py-4">{user.telefone}</td>
                  <td className="px-6 py-4 space-x-2">
                    <button
                      onClick={() => confirmEditUser(user)}
                      className="text-indigo-600 hover:text-indigo-900 dark:hover:text-indigo-400"
                    >
                      <Edit className="w-5 h-5" />
                    </button>
                    <button
                      onClick={() => confirmDeleteUser(user)}
                      className="text-red-600 hover:text-red-900 dark:hover:text-red-400"
                    >
                      <Trash2 className="w-5 h-5" />
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>

      <div className="bg-white dark:bg-gray-800 rounded-xl shadow-md p-6 transition-colors duration-200">
        <h3 className="text-lg font-semibold text-gray-700 dark:text-gray-200 mb-4">Usuários Pendentes</h3>
        <div className="overflow-x-auto">
          <table className="w-full text-sm text-left text-gray-500 dark:text-gray-400">
            <thead className="text-xs text-gray-700 uppercase bg-gray-50 dark:bg-gray-700 dark:text-gray-400">
              <tr>
                <th scope="col" className="px-6 py-3">
                  ID
                </th>
                <th scope="col" className="px-6 py-3">
                  Email
                </th>
                <th scope="col" className="px-6 py-3">
                  Usuário
                </th>
                <th scope="col" className="px-6 py-3">
                  Telefone
                </th>
                <th scope="col" className="px-6 py-3">
                  Ações
                </th>
              </tr>
            </thead>
            <tbody>
              {usuariosPendentes.map((user) => (
                <tr key={user.idUsuario} className="bg-white border-b dark:bg-gray-800 dark:border-gray-700">
                  <td className="px-6 py-4">{user.idUsuario}</td>
                  <td className="px-6 py-4">{user.email}</td>
                  <td className="px-6 py-4">{user.usuario}</td>
                  <td className="px-6 py-4">{user.telefone}</td>
                  <td className="px-6 py-4 space-x-2">
                    <button
                      onClick={() => confirmActivateUser(user)}
                      className="text-green-600 hover:text-green-900 dark:hover:text-green-400"
                    >
                      <CheckCircle className="w-5 h-5" />
                    </button>
                    <button
                      onClick={() => confirmDeleteUser(user)}
                      className="text-red-600 hover:text-red-900 dark:hover:text-red-400"
                    >
                      <Trash2 className="w-5 h-5" />
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>

      <Modal
        isOpen={isEditModalOpen}
        onRequestClose={() => setIsEditModalOpen(false)}
        style={customModalStyles}
        contentLabel="Editar Usuário"
      >
        <h2 className="text-2xl font-bold mb-4">Editar Usuário</h2>
        <div className="space-y-4">
          <div>
            <label className="block text-sm font-medium text-gray-700 dark:text-gray-300">Usuário</label>
            <input
              type="text"
              value={editedUser.usuario}
              onChange={(e) => setEditedUser({ ...editedUser, usuario: e.target.value })}
              className="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-indigo-300 focus:ring focus:ring-indigo-200 focus:ring-opacity-50"
            />
          </div>
          <div>
            <label className="block text-sm font-medium text-gray-700 dark:text-gray-300">Email</label>
            <input
              type="email"
              value={editedUser.email}
              onChange={(e) => setEditedUser({ ...editedUser, email: e.target.value })}
              className="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-indigo-300 focus:ring focus:ring-indigo-200 focus:ring-opacity-50"
            />
          </div>
          <div>
            <label className="block text-sm font-medium text-gray-700 dark:text-gray-300">Telefone</label>
            <input
              type="text"
              value={editedUser.telefone}
              onChange={(e) => setEditedUser({ ...editedUser, telefone: e.target.value })}
              className="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-indigo-300 focus:ring focus:ring-indigo-200 focus:ring-opacity-50"
            />
          </div>
          <div className="flex justify-end space-x-3 pt-4">
            <button
              onClick={() => setIsEditModalOpen(false)}
              className="px-4 py-2 border border-gray-300 rounded-md text-gray-700 hover:bg-gray-50"
            >
              Cancelar
            </button>
            <button
              onClick={handleEditUser}
              className="px-4 py-2 bg-indigo-600 text-white rounded-md hover:bg-indigo-700"
            >
              Salvar
            </button>
          </div>
        </div>
      </Modal>

      <Modal
        isOpen={isActivateModalOpen}
        onRequestClose={() => setIsActivateModalOpen(false)}
        style={customModalStyles}
        contentLabel="Confirmar Ativação"
      >
        <h2 className="text-2xl font-bold mb-4">Confirmar Ativação</h2>
        <p className="mb-4">
          Tem certeza que deseja ativar o usuário <strong>{userToActivate?.usuario}</strong>?
        </p>
        <div className="flex justify-end space-x-3">
          <button
            onClick={() => setIsActivateModalOpen(false)}
            className="px-4 py-2 border border-gray-300 rounded-md text-gray-700 hover:bg-gray-50"
          >
            Cancelar
          </button>
          <button
            onClick={handleActivateUser}
            className="px-4 py-2 bg-green-600 text-white rounded-md hover:bg-green-700"
          >
            Confirmar
          </button>
        </div>
      </Modal>

      <Modal
        isOpen={isDeleteModalOpen}
        onRequestClose={() => setIsDeleteModalOpen(false)}
        style={customModalStyles}
        contentLabel="Confirmar Exclusão"
      >
        <h2 className="text-2xl font-bold mb-4">Confirmar Exclusão</h2>
        <p className="mb-4">
          Tem certeza que deseja excluir o usuário <strong>{userToDelete?.usuario}</strong>?
        </p>
        <div className="flex justify-end space-x-3">
          <button
            onClick={() => setIsDeleteModalOpen(false)}
            className="px-4 py-2 border border-gray-300 rounded-md text-gray-700 hover:bg-gray-50"
          >
            Cancelar
          </button>
          <button onClick={handleDeleteUser} className="px-4 py-2 bg-red-600 text-white rounded-md hover:bg-red-700">
            Confirmar
          </button>
        </div>
      </Modal>

      {message && (
        <div className="fixed bottom-4 right-4 bg-green-500 text-white px-4 py-2 rounded-md shadow-lg">{message}</div>
      )}
    </div>
  )
}

export default UserManagement

